module.exports = __webpack_public_path__ + "img/banner-right.7e447b9f.svg";